import { ArchiveBoxIcon, CheckIcon } from '@heroicons/react/24/outline';
import { useState } from 'react';
import SimpleLoader from '../../../../components/Loader/SimpleLoader';
import { checkFinalResultsFile } from '../../../../services/results/resultsService';
import DELETE from './DELETE';

export default function FileCard({ file, onDelete }) {
  const [isLoading, setIsLoading] = useState(false);
  const onCheck = () => {};
  return (
    <div
      className='flex flex-row justify-between rounded-xl border bg-blue-100 px-4 py-2'
      key={file.uuid}
    >
      <div className='flex flex-col'>
        <span>Is asp: {file.is_asp ? 'TRUE' : 'FALSE'}</span>
        <span>Round: {file.round}</span>
        <span>
          File name:{' '}
          <a className='text-primary hover:underline' href={file.file}>
            {file.file?.split('media/final_results_files/')?.[1]}
          </a>
        </span>
      </div>
      <div className='flex flex-row gap-2'>
        <div
          className={`h-7 w-7 rounded-lg border border-primary p-1 text-primary ${
            !isLoading && 'cursor-pointer hover:bg-primary hover:text-white'
          }`}
          title={`${isLoading ? 'Checking' : 'Check file'}`}
        >
          {isLoading ? (
            <SimpleLoader />
          ) : file.file_status === 0 || true ? (
            <CheckIcon
              onClick={() => {
                setIsLoading(true);
                checkFinalResultsFile(file.uuid)
                  .then((res) => {})
                  .catch((e) => {
                    console.log(e);
                  })
                  .finally(() => {
                    setIsLoading(false);
                  });
              }}
            />
          ) : (
            <ArchiveBoxIcon />
          )}
        </div>
        <DELETE file={file} onDelete={onDelete} />
      </div>
    </div>
  );
}
